import { CommonModule } from '@angular/common';
import { Component, HostListener, Output, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserDetailsService } from '../services/user-details.service';
import { MessageListingComponent } from "../message-listing/message-listing.component";
import { faArrowLeft, faReply } from '@fortawesome/free-solid-svg-icons';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { Subject, Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../my-profile/services.service';


@Component({
  selector: 'app-message-tab',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatTabsModule, FontAwesomeModule, CommonModule, MessageListingComponent, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule,],
  templateUrl: './message-tab.component.html',
  styleUrl: './message-tab.component.css'
})
export class MessageTabComponent {

  formGroup: FormGroup;
  draft = false;
  send = false;
  inboxIn = false;
  back = faArrowLeft;
  replay = faReply;
  replaymsg=false;

  toOptions = [
    { value: '', viewValue: 'Select Sender' },
    { value: 'option1', viewValue: 'Option 1' },
    { value: 'option2', viewValue: 'Option 2' },
    { value: 'option3', viewValue: 'Option 3' },
  ];

  DraftMsg!: any;
  userData: any;
  friends: any;
  inbox: any;
  conversationId: any;
  conversation: any;
  shimmer = false;
  totalPages: any;
  selectedTabIndex = 0;
  participantid: any;
  con_subject: any;
  con_id = '';
  showText = false;
  draftId: any;
  del: any;
  save = false;
  inside_delete: any;
  username: any;
   private subscription!: Subscription;
  profile_completenes= true;

  constructor(private router:Router,private route: ActivatedRoute, private fb: FormBuilder, private userdetails: UserDetailsService, private apiservices: ApiServicesService, private snackbarService: SnackbarService,private taskservices: ServicesService) {
    this.formGroup = this.fb.group({
      to: ['', Validators.required],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  conversationfun(event: { ID: any, is_delete: any }) {
    this.inboxIn = true;
    this.selectedTabIndex = 0
    this.conversationId = event.ID;
    this.inside_delete = event.is_delete
    this.getInsideInbox();
    this.page = 1;
  }

  getInsideInbox() {
    if (this.inside_delete) {

      this.apiservices.getInsideDeleteMsg(this.conversationId, this.page, this.limit).subscribe({
        next: (responce: any) => {

          if (this.page == 1) {
            this.conversation = responce.messages;
          } else {
            this.conversation = [...this.conversation, ...responce.messages];
          }

          
          this.participantid = responce.participant?.userId;
          this.con_subject = responce.subject;
          this.con_id = responce.conversationID;

          this.shimmer = false;
          this.totalPages = responce?.pagination?.totalPages;
        },
        error: (err) => {
        }
      });

    } else {

      this.apiservices.getInsideInboxMsg(this.conversationId, this.page, this.limit).subscribe({
        next: (responce: any) => {

          if (this.page == 1) {
            this.conversation = responce.messages;
          } else {
            this.conversation = [...this.conversation, ...responce.messages];
          }

          this.username=responce.participant.userName;
          this.participantid = responce.participant?.userId;
          this.con_subject = responce.subject;
          this.con_id = responce.conversationID;
          this.shimmer = false;
          this.totalPages = responce?.pagination?.totalPages;
        },
        error: (err) => {
        }
      });

    }

  }

  back_inbox() {
    this.inboxIn = false;
    this.page = 1;
    this.con_subject = '';
    this.con_id = '';
    this.draftId = '';

    this.conversationId = '';
  }

  go_toInbox() {
    this.selectedTabIndex = 0;
  }

  onTabChange(event: MatTabChangeEvent) {

    this.selectedTabIndex = event.index;
    this.page = 1;
    if (this.inboxIn) {
      this.formGroup.get('to')?.enable();
      this.formGroup.get('subject')?.enable();
    }

    if (!event.tab.textLabel.includes('Inbox')) {
      this.inboxIn = false;
    }

    if (event.tab.textLabel != 'Compose') {
      this.formGroup.reset();
      this.formGroup.patchValue({
        to: '',
      });
      this.conversationId = '';
      this.draftId = '';
      this.formGroup.get('to')?.enable();
      this.formGroup.get('subject')?.enable();
      this.itsDraft = false;
      this.replaymsg=false;
    }

    if (event.tab.textLabel === 'Draft') {
      this.draft = true;
      this.send = false;
      this.inbox = false;
      this.del = false;
    }
    if (event.tab.textLabel.includes('Sent')) {
      this.send = true;
      this.draft = false;
      this.inbox = false;
      this.del = false;
    }

    if (event.tab.textLabel.includes('Inbox')) {
      this.inbox = true;
      this.send = false;
      this.draft = false;
      this.del = false;
    }


    if (event.tab.textLabel.includes('Compose')) {
      // this.resetForm();

      // this.formGroup.markAsUntouched();
      this.inbox = false;
      this.send = false;
      this.draft = false;
      this.del = false;

      // this.formGroup.removeValidators
      if (!this.itsDraft) {
        this.userdetails.userdetails$.subscribe((userData) => {
          this.userData = userData;
          if (userData && userData.user) {
            this.userId = this.userData.user._id;

            if(!this.replaymsg){
            this.getFriendList(this.page, this.limit);
            }
          }
        });
      } else {
        this.formGroup.get('to')?.disable();
        if(this.con_id!=null){
          this.formGroup.get('subject')?.disable();
        }
      }
      
    }

    if (event.tab.textLabel.includes('Deleted')) {
      this.inbox = false;
      this.send = false;
      this.draft = false;
      this.del = true;
    }
  }


  userId: any;
  page = 1;
  limit = 10;
  itsDraft = false;

  ngOnInit() {
    this.shimmer = true;
    this.inbox = true;

    const receiverId = this.route.snapshot.queryParamMap.get('receiver_id');
    const username = this.route.snapshot.queryParamMap.get('username');

    // Check if both parameters exist
    if (receiverId && username) {

      // Add your custom script or functionality here
      this.msgFromMember(receiverId, username);
    } else {
    }

    this.subscription = this.taskservices.changeFriendsTab$.subscribe((data) => {
      if(data==1){
        this.selectedTabIndex=0;
        // this.taskservices.changefriTabrevert();
      }
    });

    this.userdetails.userdetails$.subscribe((userData) => {
      // console.log(userData)
      if (userData && userData.user) {
        this.userData=userData;
        this.profile_completenes=userData.user.profileCompleteness==1? true : false;
      }
    });
    
  }


  navigate(){
    this.router.navigate(["/my-profile", this.userData.user.username, 'edit_form']);
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  msgFromMember(receiverId: string, username: string): void {
    this.selectedTabIndex = 1;
    // Convert the receiverId and username into a JSON object
    this.friends = [{
      id: receiverId,
      username: username
    }];

    this.formGroup.patchValue({
      to: receiverId,
    });

  }



  getFriendList(page: any, limit: any) {
    if (this.userId) {
      this.apiservices.getCombinedList(page, limit).subscribe({
        next: (friends: any) => {
          this.friends = friends.allFriends;
          // console.log("compose",this.friends)
        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    }
  }
  // Flag for sendMsg
  isSendMsgProcessing: boolean = false;

  // Flag for sendConMsg
  isSendConMsgProcessing: boolean = false;

  sendMsg(targetUserId: any, subject: any, body: any) {
    if (this.isSendMsgProcessing) {
      return; // Exit if the function is already processing
    }

    this.isSendMsgProcessing = true; // Set the flag
    this.showText = true;

    this.apiservices.SendMsg(targetUserId, subject, body,this.draftId).subscribe({
      next: (response: any) => {
        this.isSendMsgProcessing = false; // Reset the flag
        this.formGroup.reset();
        this.formGroup.get('to')?.enable();
        this.formGroup.get('subject')?.enable();
        this.selectedTabIndex = 0;
        this.page = 1;
        this.showText = false;
        this.snackbarService.openCustomSnackbar({
          icon: true,
          message: 'Message sent successfully',
          className: 'success',
        });
      },
      error: (err) => {
        this.isSendMsgProcessing = false; // Reset the flag on error
        this.showText = false;
      }
    });
  }

  sendConMsg(targetUserId: any, body: any) {
    if (this.isSendConMsgProcessing) {
      return; // Exit if the function is already processing
    }

    this.isSendConMsgProcessing = true; // Set the flag
    this.showText = true;

    this.apiservices.SendConMsg(this.con_id, targetUserId, body, this.formGroup.get("subject")?.value,this.draftId).subscribe({
      next: (response: any) => {
        this.isSendConMsgProcessing = false; // Reset the flag
        this.formGroup.patchValue({
          to: '',
          subject: '',
        });
        this.conversationId ='';
        this.con_id='';
        this.formGroup.get('to')?.enable();
        this.formGroup.get('subject')?.enable();
        this.selectedTabIndex = 0;
        this.page = 1;
        this.showText = false;
        this.snackbarService.openCustomSnackbar({
          icon: true,
          message: response.message,
          className: 'success',
        });
      },
      error: (err) => {
        this.isSendConMsgProcessing = false; // Reset the flag on error
        this.showText = false;
        this.conversationId ='';
        this.con_id='';
        
      }
    });
  }


  SaveDraftMsg() {
    if (this.formGroup.valid) {
      this.save = true;
      const targetUserId = this.formGroup.get('to')?.value;
      const subject = this.formGroup.get('subject')?.value;
      const body = this.formGroup.get('message')?.value;
      const draftID = this.draftId;
      const conId = this.conversationId;
      this.apiservices.saveMsg(targetUserId, subject, body, draftID, conId).subscribe({
        next: (responce: any) => {
          if(responce.status==200){
          this.save = false;

          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: responce.message,
              className: 'success',
            }
          );
          this.selectedTabIndex = 3;
        }else{
          this.save = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );

        }
        },
        error: (err) => {
        }
      });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  @ViewChild(MessageListingComponent) messageListing!: MessageListingComponent;

  replay_msg(username:any) {
    this.selectedTabIndex = 1;
    this.inboxIn = false;
    this.replaymsg=true;
    const newFriend = {
      id: this.participantid,
      username: username,
    };
    this.friends = this.friends ? [...this.friends, newFriend] : [newFriend];
    this.formGroup.patchValue({
      to: String(this.participantid),
      subject: this.con_subject,
    });

   

    this.conversationId = this.con_id;

    this.formGroup.get('to')?.disable();
    this.formGroup.get('subject')?.disable();
    this.inbox = false;
    this.inbox = false;
  }

  editDraft(event: { id: number; userId: string; body: any; subject: any; conversationId: any, username: any }) {
    this.selectedTabIndex = 1;
    this.draftId = event.id;
    this.itsDraft = true;

    const newFriend = {
      id: event.userId,
      username: event.username,
    };


    this.friends = this.friends ? [...this.friends, newFriend] : [newFriend];

    this.formGroup.patchValue({
      to: event.userId,
      subject: event.subject,
      message: event.body
    });
    this.conversationId = event.conversationId;
    this.con_id = event.conversationId;


    // console.log('this.conversationId',this.conversationId)
    // console.log('this.con_id',this.con_id)
  }



  onSubmit() {
    if (this.formGroup.valid) {
      const targetUserId = this.formGroup.get('to')?.value;
      const subject = this.formGroup.get('subject')?.value;
      const body = this.formGroup.get('message')?.value;

      if (this.con_id) {
        this.sendConMsg(targetUserId, body)
      } else {
        this.sendMsg(targetUserId, subject, body)
      }

    } else {
      this.formGroup.markAllAsTouched();
    }
  }


  @HostListener('window:scroll', ["$event"])
  onScroll(event: Event): void {
    const target = event.target as Document;
    const scrollTop = target.scrollingElement?.scrollTop || 0;
    const innerHeight = window.innerHeight;
    const scrollHeight = target.scrollingElement?.scrollHeight || 0;
    if (
      innerHeight + scrollTop >= scrollHeight - 100 && !this.shimmer && this.conversation && (this.page < this.totalPages)) {
      this.shimmer = true;
      if (this.inboxIn) {
        this.page++;
        this.getInsideInbox();
      }
    }
  }



}
